import { render, staticRenderFns } from "./BlockOpenCloze.vue?vue&type=template&id=b4659ece&scoped=true"
import script from "./BlockOpenCloze.vue?vue&type=script&lang=js"
export * from "./BlockOpenCloze.vue?vue&type=script&lang=js"
import style0 from "./BlockOpenCloze.vue?vue&type=style&index=0&id=b4659ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4659ece",
  null
  
)

export default component.exports